import { AdminResourceEditor } from "./AdminResourceEditor";

const FIELDS = [
  { name: "class_type", label: "Class Type (e.g. WOD — Metcon)" },
  { name: "coach", label: "Coach" },
  { name: "date", label: "Date (YYYY-MM-DD)" },
  { name: "start_time", label: "Start Time (HH:MM)" },
  { name: "duration_minutes", label: "Duration (minutes)", type: "number" },
  { name: "capacity", label: "Capacity", type: "number" },
  { name: "description", label: "Description", type: "textarea", required: false },
];

const DEFAULTS = { class_type: "", coach: "", date: "", start_time: "", duration_minutes: 60, capacity: 15, description: "" };

export default function AdminClasses() {
  return (
    <AdminResourceEditor
      resourceLabel="Class Session"
      apiPath="/admin/classes"
      fields={FIELDS}
      defaultValues={DEFAULTS}
      renderItem={(item) => (
        <>
          <p className="text-cream truncate">{item.class_type} &middot; {item.coach}</p>
          <p className="text-smoke text-xs mt-1">{item.date} at {item.start_time} &middot; {item.booked_count}/{item.capacity} booked</p>
        </>
      )}
    />
  );
}
